/**
 * ADDE — Ommaviy oferta (uz / ru / en)
 * URL: https://addegroup.uz/offer/{uz|ru|en}
 */

const effectiveDate = '2026-05-20';

export const publicOffer = {
  uz: {
    title: 'Ommaviy oferta',
    effectiveDate,
    intro:
      'Ushbu hujjat ADDE platformasidan foydalanish shartlarini (ommaviy oferta) belgilaydi. Platformadan ro‘yxatdan o‘tish, kirish yoki funksiyalardan foydalanish ushbu ofertani to‘liq qabul qilish hisoblanadi.',
    sections: [
      {
        title: '1. Tomonlar va predmet',
        body: [
          'Operator — ADDE platformasini taqdim etuvchi shaxs (keyingi o‘rinlarda «Biz»).',
          'Mijoz (Foydalanuvchi) — Platformadan biznes maqsadlarida foydalanuvchi yuridik yoki jismoniy shaxs yoki uning vakili («Siz»).',
          'Predmet — savdo, ombor, moliya, hisobot, marketing va boshqa ERP funksiyalarini bulut (SaaS) modelida taqdim etish.',
        ],
      },
      {
        title: '2. Xizmatdan foydalanish',
        body: [
          'Kirish telefon raqami va parol + SMS tasdiqlash orqali amalga oshiriladi (rol bo‘yicha cheklovlar qo‘llanishi mumkin).',
          'Siz taqdim etilgan ma’lumotlarning to‘g‘riligi va maxfiyligini ta’minlaysiz.',
          'Platformadan faqat qonuniy faoliyat uchun foydalanish shart.',
          'Zararli kod, ruxsatsiz kirish, boshqa foydalanuvchi ma’lumotlarini o‘g‘irlash taqiqlanadi.',
        ],
      },
      {
        title: '3. Tariflar va to‘lov',
        body: [
          'Tariflar Platformada e’lon qilingan narxlar va funksiyalar bo‘yicha belgilanadi; Operator narxni oldindan ogohlantirish bilan o‘zgartirishi mumkin.',
          'To‘lov Click, Payme yoki boshqa qo‘llab-quvvatlanadigan provayderlar orqali amalga oshiriladi.',
          'Sinov muddati (agar berilgan bo‘lsa) tugagach, to‘lov qilinmasa, funksiyalar cheklanishi yoki to‘xtatilishi mumkin.',
          'Qaytarilgan to‘lovlar amaldagi qonunchilik va Operator siyosatiga muvofiq ko‘rib chiqiladi.',
        ],
      },
      {
        title: '4. Intellektual mulk',
        body: [
          'Platforma dasturi, dizayn, logotip va hujjatlar Operator mulki hisoblanadi.',
          'Mijoz o‘z kiritgan ma’lumotlar (mahsulotlar, buyurtmalar va h.k.) bo‘yicha huquqlarni saqlaydi; Platformadan foydalanish uchun Operatorga cheklangan litsenziya beriladi.',
        ],
      },
      {
        title: '5. Maxfiylik',
        body: [
          'Shaxsiy ma’lumotlar qayta ishlash Maxfiylik siyosatiga muvofiq amalga oshiriladi: https://addegroup.uz/privacy/uz',
        ],
      },
      {
        title: '6. Kafolatlar cheklovi',
        body: [
          'Platforma «boricha» (as is) taqdim etiladi. Operator uzluksiz ishlash, xatolarsizlik yoki ma’lumot yo‘qotilmasligini kafolatlamaydi.',
          'Reja bo‘yicha texnik ishlar va fors-major holatlari xizmat vaqtincha to‘xtashi mumkin.',
        ],
      },
      {
        title: '7. Javobgarlik',
        body: [
          'Operator Mijozning noto‘g‘ri ma’lumot kiritishi, uchinchi shaxs provayderlari (SMS, to‘lov, internet) yoki Mijoz tomonidan ruxsatsiz foydalanish oqibatida yuzaga kelgan zarar uchun javobgar emas, qonunda boshqacha tartib nazarda tutilgan bo‘lmasa.',
          'Operatorning umumiy javobgarligi oxirgi 12 oy davomida Mijoz tomonidan to‘langan obuna summasidan oshmasligi mumkin.',
        ],
      },
      {
        title: '8. Hisobni to‘xtatish',
        body: [
          'Mijoz qo‘llab-quvvatlash orqali hisobni yopishni so‘rashi mumkin.',
          'Oferta buzilishi, to‘lov kechikishi yoki xavfsizlik xavfi bo‘lsa, Operator kirishni vaqtincha yoki doimiy bloklash huquqiga ega.',
        ],
      },
      {
        title: '9. Nizolar',
        body: [
          'Nizolar muzokara yo‘li bilan hal etiladi; kelishuv bo‘lmasa, O‘zbekiston Respublikasi qonunchiligiga muvofiq vakolatli sudda ko‘rib chiqiladi.',
        ],
      },
      {
        title: '10. Yakuniy qoidalar',
        body: [
          'Oferta kuchga kirish sanasi sahifa boshida ko‘rsatiladi.',
          'Operator ofertani yangilashi mumkin; yangi tahrir e’lon qilingan kundan kuchga kiradi.',
          'Savollar: info@adde.app',
        ],
      },
    ],
  },
  ru: {
    title: 'Публичная оферта',
    effectiveDate,
    intro:
      'Настоящий документ является публичной офертой на использование платформы ADDE. Регистрация, вход или использование функций означает полное принятие условий оферты.',
    sections: [
      {
        title: '1. Стороны и предмет',
        body: [
          'Оператор — лицо, предоставляющее платформу ADDE (далее — «Мы»).',
          'Клиент (Пользователь) — юридическое или физическое лицо либо его представитель, использующий Платформу в бизнес-целях («Вы»).',
          'Предмет — предоставление функций ERP (продажи, склад, финансы, отчёты, маркетинг и др.) по модели SaaS.',
        ],
      },
      {
        title: '2. Использование сервиса',
        body: [
          'Вход осуществляется по номеру телефона, паролю и SMS-подтверждению (могут применяться ограничения по ролям).',
          'Вы обеспечиваете достоверность и конфиденциальность предоставленных данных.',
          'Использование Платформы только в законных целях.',
          'Запрещены вредоносный код, несанкционированный доступ и кража данных других пользователей.',
        ],
      },
      {
        title: '3. Тарифы и оплата',
        body: [
          'Тарифы определяются ценами и функциями, опубликованными на Платформе; Оператор вправе изменять цены с предварительным уведомлением.',
          'Оплата производится через Click, Payme или иных поддерживаемых провайдеров.',
          'После окончания пробного периода (если предоставлен) при неоплате функции могут быть ограничены или приостановлены.',
          'Возвраты рассматриваются в соответствии с законодательством и политикой Оператора.',
        ],
      },
      {
        title: '4. Интеллектуальная собственность',
        body: [
          'Программное обеспечение, дизайн, логотип и документация Платформы принадлежат Оператору.',
          'Клиент сохраняет права на введённые данные; для использования Платформы предоставляется ограниченная лицензия Оператору.',
        ],
      },
      {
        title: '5. Конфиденциальность',
        body: [
          'Обработка персональных данных осуществляется согласно Политике конфиденциальности: https://addegroup.uz/privacy/ru',
        ],
      },
      {
        title: '6. Ограничение гарантий',
        body: [
          'Платформа предоставляется «как есть». Оператор не гарантирует бесперебойную работу, отсутствие ошибок или потери данных.',
          'Плановые работы и форс-мажор могут временно ограничить доступ.',
        ],
      },
      {
        title: '7. Ответственность',
        body: [
          'Оператор не несёт ответственности за ущерб из-за неверных данных Клиента, сбоев провайдеров (SMS, платежи, интернет) или несанкционированного использования, если иное не предусмотрено законом.',
          'Совокупная ответственность Оператора может быть ограничена суммой подписки, уплаченной Клиентом за последние 12 месяцев.',
        ],
      },
      {
        title: '8. Прекращение доступа',
        body: [
          'Клиент может запросить закрытие аккаунта через поддержку.',
          'При нарушении оферты, просрочке оплаты или угрозе безопасности Оператор вправе временно или постоянно заблокировать доступ.',
        ],
      },
      {
        title: '9. Споры',
        body: [
          'Споры разрешаются путём переговоров; при недостижении соглашения — в компетентном суде Республики Узбекистан.',
        ],
      },
      {
        title: '10. Заключительные положения',
        body: [
          'Дата вступления в силу указана в начале страницы.',
          'Оператор вправе обновлять оферту; новая редакция вступает в силу с момента публикации.',
          'Вопросы: info@adde.app',
        ],
      },
    ],
  },
  en: {
    title: 'Public Offer (Terms of Service)',
    effectiveDate,
    intro:
      'This document is a public offer governing use of the ADDE platform. By registering, signing in, or using any feature, you fully accept these terms.',
    sections: [
      {
        title: '1. Parties and subject',
        body: [
          'Operator — the provider of the ADDE platform (“We”).',
          'Customer (User) — a business entity or individual (or representative) using the Platform for business purposes (“You”).',
          'Subject — provision of ERP features (sales, inventory, finance, reports, marketing, etc.) as a cloud (SaaS) service.',
        ],
      },
      {
        title: '2. Use of the service',
        body: [
          'Access requires phone number, password, and SMS verification (role-based restrictions may apply).',
          'You are responsible for the accuracy and confidentiality of data you provide.',
          'The Platform must be used only for lawful purposes.',
          'Malware, unauthorized access, and misuse of other users’ data are prohibited.',
        ],
      },
      {
        title: '3. Plans and payment',
        body: [
          'Plans are defined by prices and features published on the Platform; the Operator may change prices with prior notice.',
          'Payments are processed via Click, Payme, or other supported providers.',
          'After any trial period ends, non-payment may limit or suspend features.',
          'Refunds are handled under applicable law and the Operator’s policy.',
        ],
      },
      {
        title: '4. Intellectual property',
        body: [
          'Platform software, design, logos, and documentation belong to the Operator.',
          'You retain rights to data you enter; a limited license is granted to the Operator to host and process it for the service.',
        ],
      },
      {
        title: '5. Privacy',
        body: [
          'Personal data is processed under the Privacy Policy: https://addegroup.uz/privacy/en',
        ],
      },
      {
        title: '6. Disclaimer of warranties',
        body: [
          'The Platform is provided “as is”. We do not warrant uninterrupted operation, error-free performance, or absence of data loss.',
          'Scheduled maintenance and force majeure may temporarily affect availability.',
        ],
      },
      {
        title: '7. Limitation of liability',
        body: [
          'We are not liable for damages caused by incorrect Customer data, third-party providers (SMS, payments, internet), or unauthorized use, except as required by law.',
          'Our aggregate liability may be capped at subscription fees paid by you in the preceding 12 months.',
        ],
      },
      {
        title: '8. Account termination',
        body: [
          'You may request account closure via support.',
          'We may suspend or terminate access for breach, non-payment, or security risk.',
        ],
      },
      {
        title: '9. Disputes',
        body: [
          'Disputes shall first be resolved by negotiation; failing that, competent courts of the Republic of Uzbekistan apply.',
        ],
      },
      {
        title: '10. Final provisions',
        body: [
          'The effective date is shown at the top of this page.',
          'We may update this offer; the new version takes effect upon publication.',
          'Contact: info@adde.app',
        ],
      },
    ],
  },
};
